import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type CreateBatchReferralResponse = {
  __typename?: 'CreateBatchReferralResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateBatchReferralsInput = {
  clinicianId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  referrals: Array<CreateReferralInput>;
};

export type CreateReferralInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type GetOrgStatsInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  serviceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetOrgStatsResponse = {
  __typename?: 'GetOrgStatsResponse';
  accountCreatedCount: Scalars['Int']['output'];
  cancelledCount: Scalars['Int']['output'];
  completionRatePercentage?: Maybe<Scalars['Float']['output']>;
  expiredCount: Scalars['Int']['output'];
  inviteCount: Scalars['Int']['output'];
  reportsCompletedCount: Scalars['Int']['output'];
};

export type GetReferralSessionFilters = {
  fromCompletedDate?: InputMaybe<Scalars['Date']['input']>;
  fromReferralDate?: InputMaybe<Scalars['Date']['input']>;
  serviceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  showCompletedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  toCompletedDate?: InputMaybe<Scalars['Date']['input']>;
  toReferralDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetReferralSessionsInput = {
  filters?: InputMaybe<GetReferralSessionFilters>;
  pagedQuery?: InputMaybe<PagedQuery>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortParams>;
};

export type GetReferralSessionsResponse = {
  __typename?: 'GetReferralSessionsResponse';
  sessions: Array<ReferralSession>;
  totalCount: Scalars['Int']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
  respondentType: RespondentType;
  serviceUserLink: Scalars['String']['output'];
  status: InviteStatus;
};

export enum InviteStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  Pending = 'pending'
}

export type Mutation = {
  __typename?: 'Mutation';
  createBatchReferrals: CreateBatchReferralResponse;
};


export type MutationCreateBatchReferralsArgs = {
  batchReferralsInput: CreateBatchReferralsInput;
};

export type OrganisationServicesResponse = {
  __typename?: 'OrganisationServicesResponse';
  services: Array<Service>;
};

export type PagedQuery = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type Patient = {
  __typename?: 'Patient';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  piSystemId: PiSystemId;
};

export type PiSystemId = {
  __typename?: 'PiSystemId';
  id: Scalars['String']['output'];
  system: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getOrgStats: GetOrgStatsResponse;
  getOrganisationServices: OrganisationServicesResponse;
  getReferralSessions: GetReferralSessionsResponse;
};


export type QueryGetOrgStatsArgs = {
  input: GetOrgStatsInput;
};


export type QueryGetReferralSessionsArgs = {
  input: GetReferralSessionsInput;
};

export type Referral = {
  __typename?: 'Referral';
  id: Scalars['ID']['output'];
  patient: Patient;
  service: Service;
};

export type ReferralSession = {
  __typename?: 'ReferralSession';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invites: Array<Invite>;
  referral: Referral;
  reportAvailable?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
};

export enum ReferralSortField {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  PiSystemId = 'piSystemId',
  Status = 'status'
}

export enum RespondentType {
  Carer = 'carer',
  Informant1 = 'informant1',
  Patient = 'patient'
}

export type Service = {
  __typename?: 'Service';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortParams = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ReferralSortField>;
};

export type GetReferralSessionsQueryVariables = Exact<{
  input: GetReferralSessionsInput;
}>;


export type GetReferralSessionsQuery = { __typename?: 'Query', getReferralSessions: { __typename?: 'GetReferralSessionsResponse', totalCount: number, sessions: Array<{ __typename?: 'ReferralSession', completedAt?: any | null, createdAt: any, id: string, reportAvailable?: boolean | null, status: string, referral: { __typename?: 'Referral', id: string, patient: { __typename?: 'Patient', familyName: string, givenName: string, piSystemId: { __typename?: 'PiSystemId', id: string, system: string } }, service: { __typename?: 'Service', code: string, description: string } }, invites: Array<{ __typename?: 'Invite', id: string, givenName: string, familyName: string, respondentType: RespondentType, status: InviteStatus, publicId: string, serviceUserLink: string }> }> } };

export type GetOrgStatsQueryVariables = Exact<{
  input: GetOrgStatsInput;
}>;


export type GetOrgStatsQuery = { __typename?: 'Query', getOrgStats: { __typename?: 'GetOrgStatsResponse', inviteCount: number, completionRatePercentage?: number | null, cancelledCount: number, expiredCount: number, accountCreatedCount: number, reportsCompletedCount: number } };

export type GetOrganisationServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationServicesQuery = { __typename?: 'Query', getOrganisationServices: { __typename?: 'OrganisationServicesResponse', services: Array<{ __typename?: 'Service', code: string, description: string }> } };


export const GetReferralSessionsDocument = gql`
    query GetReferralSessions($input: GetReferralSessionsInput!) {
  getReferralSessions(input: $input) {
    totalCount
    sessions {
      completedAt
      createdAt
      id
      referral {
        id
        patient {
          familyName
          givenName
          piSystemId {
            id
            system
          }
        }
        service {
          code
          description
        }
      }
      invites {
        id
        givenName
        familyName
        respondentType
        status
        publicId
        serviceUserLink
      }
      reportAvailable
      status
    }
  }
}
    `;

export function useGetReferralSessionsQuery(options: Omit<Urql.UseQueryArgs<GetReferralSessionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReferralSessionsQuery, GetReferralSessionsQueryVariables>({ query: GetReferralSessionsDocument, ...options });
};
export const GetOrgStatsDocument = gql`
    query GetOrgStats($input: GetOrgStatsInput!) {
  getOrgStats(input: $input) {
    inviteCount
    completionRatePercentage
    cancelledCount
    expiredCount
    accountCreatedCount
    reportsCompletedCount
  }
}
    `;

export function useGetOrgStatsQuery(options: Omit<Urql.UseQueryArgs<GetOrgStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgStatsQuery, GetOrgStatsQueryVariables>({ query: GetOrgStatsDocument, ...options });
};
export const GetOrganisationServicesDocument = gql`
    query GetOrganisationServices {
  getOrganisationServices {
    services {
      code
      description
    }
  }
}
    `;

export function useGetOrganisationServicesQuery(options?: Omit<Urql.UseQueryArgs<GetOrganisationServicesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganisationServicesQuery, GetOrganisationServicesQueryVariables>({ query: GetOrganisationServicesDocument, ...options });
};